import React, { Component } from "react";
import { connect } from "react-redux";
import parseTimezone from "../../lib/helperServices";
import {
  Container,
  Header,
  Button,
  Grid,
  Dropdown,
  Segment,
  Form,
  Icon,
} from "semantic-ui-react";
import DatePicker from "react-datepicker";
import ExamDetails from "./ExamDetails";
import {
  fetchBookingTimesForDate,
  fetchBookingsForUser,
  fetchNextAvailableBooking,
} from "../../reducers/exam";
import { withTranslation } from "react-i18next";
import { DateTime } from "luxon";
import i18n from "../../i18n";
import { enUS, fr } from "date-fns/locale";

const DAYS_OF_WEEKS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

import {
  getBlockedDaysForSixMonths,
  getIncludedDaysForSixMonths,
} from "./../../reducers/booking";
import { addMonths, addHours, format, isBefore, parse } from "date-fns";

class SelectDates extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    let times = [];

    this.minDate = new Date();
    this.maxDate = addMonths(new Date(), 5);

    // Get time format based on current language
    const currentLang = i18n.language || localStorage.getItem("lang") || "en";
    this.timeFormat = currentLang === "en" ? "hh:mm a" : "HH:mm";

    if(localStorage.getItem("lang") === "fr"){
      this.timeFormat = "HH:mm"; // 24-hour format
    }

    let dateFormat = localStorage.getItem("lang") === "en" ? "yyyy-MM-dd" : "dd-MM-yyyy"

    if(localStorage.getItem("lang") === "fr"){
      this.timeFormat = "HH:mm"; // 24-hour format
    }


    if (
      this.props.formData.exam.available_from_time &&
      this.props.formData.exam.available_to_time
    ) {
      let available_from_time = parse(
        this.props.formData.exam.available_from_time,
        "HH:mm:ss",
        new Date()
      );

      let available_to_time = parse(
        this.props.formData.exam.available_to_time,
        "HH:mm:ss",
        new Date()
      );

      while (isBefore(available_from_time, available_to_time)) {
        times.push({
          text: format(available_from_time, this.timeFormat),
          value: format(available_from_time, "HH:mm"),
        });
        available_from_time = addHours(available_from_time, 1);
      }
    } else {
      // Use translated time options from language file
      const defaultTimes = this.props.t("SelectDates.defaultTimes");
      const timeValues = ["09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00"];
      if (Array.isArray(defaultTimes) && defaultTimes.length > 0) {
        times = defaultTimes.map((timeText, index) => ({
          text: timeText,
          value: timeValues[index] || timeValues[0],
        }));
      } else {
        // Fallback if translation not found
        times = [
          { text: "9:00 AM", value: "9:00" },
          { text: "10:00 AM", value: "10:00" },
          { text: "11:00 AM", value: "11:00" },
          { text: "12:00 PM", value: "12:00" },
          { text: "1:00 PM", value: "13:00" },
          { text: "2:00 PM", value: "14:00" },
          { text: "3:00 PM", value: "15:00" },
        ];
      }
    }

    this.timezone = parseTimezone(
      this.props.kc.tokenParsed.timezone,
      this.props.kc.tokenParsed.province
    );

    this.available_times = times.map((data) => {
      const [hour, minute] = data.value.split(":").map(Number);
      //we know dates are saved in the database in America/Halifax (atlantic) so parse the time on todays date (as a placeholder)
      // as Atlantic. We were  and not having an issue where it was parsing it in the users timezoneatlantic.
      const atlanticDateTime = DateTime.now()
        .setZone("America/Halifax")
        .set({ hour, minute, second: 0, millisecond: 0 });

      //NOW we convert it to the users timezone set in their account.
      const targetTime = atlanticDateTime.setZone(this.timezone);

      // Get timezone abbreviation and simplify (e.g., "NST" -> "NT", "EST" -> "ET")
      const fullTimezoneAbbr = targetTime.toFormat("z");
      const timezoneAbbr = fullTimezoneAbbr.replace(/[SD]T$/, "T");

      return {
        value: data.value,
        text: `${targetTime.toFormat(this.timeFormat)} ${timezoneAbbr}`,
      };
    });

    window.addEventListener("language-changed", () => {
      let format = localStorage.getItem("lang") === "en" ? "hh:mm a" : "HH:mm";
      let dateFormat = localStorage.getItem("lang") === "en" ? "yyyy-MM-dd" : "dd-MM-yyyy"
      let times = this.props.formData.available_times || this.available_times;
      this.available_times = times.map((data) => {
        const [hour, minute] = data.value.split(":").map(Number);
        //we know dates are saved in the database in America/Halifax (atlantic) so parse the time on todays date (as a placeholder)
        // as Atlantic. We were  and not having an issue where it was parsing it in the users timezoneatlantic.
        const atlanticDateTime = DateTime.now()
          .setZone("America/Halifax")
          .set({ hour, minute, second: 0, millisecond: 0 });

        //NOW we convert it to the users timezone set in their account.
        const targetTime = atlanticDateTime.setZone(this.timezone);

        // Get timezone abbreviation and simplify (e.g., "NST" -> "NT", "EST" -> "ET")
        const fullTimezoneAbbr = targetTime.toFormat("z");
        const timezoneAbbr = fullTimezoneAbbr.replace(/[SD]T$/, "T");
        return {
          value: data.value,
          text: `${targetTime.toFormat(format)} ${timezoneAbbr}`,
        };
      });
      this.setState({
        available_times: this.props.formData.available_times || this.available_times,
        dateFormat: dateFormat
      });
    });

    this.state = {
      examDate: null,
      examTime: null,
      available_times:
        this.props.formData.available_times || this.available_times,
      datePickerLoading: true,
      bookLimit: "",
      nextAvailable: null,
      dateFormat: dateFormat,
    };
  }

  async componentDidMount() {
    await this.props.getIncludedDaysForSixMonths(this.props.formData.exam.id);

    // Get current language from i18n
    const currentLang = i18n.language || localStorage.getItem("lang") || "en";
    
    this.setState({ datePickerLoading: false });
    this.props
      .fetchBookingsForUser(
        this.props.formData.exam.id,
        this.props.kc.tokenParsed.sub
      )
      .then((limit) => {
        this.setState({ bookLimit: limit });
      });
    let nextAvailable = await this.props.fetchNextAvailableBooking(
      this.props.formData.exam.id,
      this.props.kc.tokenParsed.sub
    );

    if (nextAvailable) {
      // Convert from UTC to Atlantic timezone
      const atlanticDT = DateTime.fromISO(nextAvailable, { zone: "utc" }).setZone('America/Halifax');
      const atlanticDate = atlanticDT.toFormat('yyyy-MM-dd');
      
      // Extract time in Atlantic timezone (HH:mm format)
      const timeInHHmm = atlanticDT.toFormat('HH:mm');
      
      // For display, convert to user's account timezone
      const userTZDate = atlanticDT.setZone(this.timezone).toJSDate();
      
      // Fetch times for the correct date (in Atlantic timezone)
      this.props.fetchBookingTimesForDate(
        this.props.formData.exam.id,
        atlanticDate
      ).then((times) => {
        // available.value is always 24-hour ("09:00") - compare against that,
        // not this.timeFormat, which is 12-hour ("hh:mm a") for English and
        // would never match, marking every slot disabled/"Fully Booked".
        const mappedTimes = times.map((time) =>
          format(parse(time, "HH:mm:ss", new Date()), "HH:mm")
        );
        let availableTimes = this.available_times.map((available) => {
          const disabled = mappedTimes.indexOf(available.value) === -1;
          return Object.assign({}, available, {
            disabled,
            text: disabled
              ? `${available.text} - ${this.props.t(
                  "SelectDates.fullyBooked"
                )}`
              : available.text,
          });
        });
        this.setState({ available_times: availableTimes });
      });
      
      this.setState({
        nextAvailable: userTZDate,
        examDate: userTZDate,
        examTime: timeInHHmm,
      });
    }
  }
   updateExamDate = (date) => {
    if (date) {
      // The DatePicker provides a JS Date representing the calendar date selected by the user.
      // We need to extract the calendar date (yyyy-MM-dd) and use that as the Atlantic date.
      // Using format() here is correct because the user sees the calendar in browser TZ
      // and we want the date they clicked on.
      const calendarDate = format(date, "yyyy-MM-dd");
      
      this.props
        .fetchBookingTimesForDate(
          this.props.formData.exam.id,
          calendarDate
        )
        .then((times) => {
          const mappedTimes = times.map((time) =>
            format(parse(time, "HH:mm:ss", new Date()), "HH:mm")
          );
          let availableTimes = this.available_times.map((available) => {
            const disabled = mappedTimes.indexOf(available.value) === -1;
            return Object.assign({}, available, {
              disabled,
              text: disabled
                ? `${available.text} - ${this.props.t(
                    "SelectDates.fullyBooked"
                  )}`
                : available.text,
            });
          });

          this.setState({
            available_times: availableTimes,
            examDate: date,
            examTime: null,
          });
        });
    } else {
      this.setState({
        examDate: date,
        examTime: null,
      });
    }
  };

  getDatePickerLocale = () => {
    const currentLang = i18n.language || localStorage.getItem("lang") || "en";
    return currentLang === "fr" ? fr : enUS;
  };
  
  getDatePickerFormat = () => {
    const currentLang = i18n.language || localStorage.getItem("lang") || "en";
    return currentLang === "en" ? "MM/dd/yyyy" : "dd/MM/yyyy";
  };

  updateExamTime = (e, { text, value }) => {
    const dateInAtlantic = DateTime.fromJSDate(this.state.examDate, {
      zone: "America/Halifax",
    });
    const [hour, minute] = value.split(":").map(Number);

    const atlanticDateTime = dateInAtlantic.set({
      hour,
      minute,
      second: 0,
      millisecond: 0,
    });

    const examDate = atlanticDateTime.setZone(this.timezone);
    this.setState({
      examTime: value,
      examDate: examDate.toJSDate(),
    });
  };
  onSubmit = (event, data) => {
    event.preventDefault();
    if (this.state.examDate && this.state.examTime) {
      this.props.onForward({
        examDate: this.state.examDate,
        examTime: this.state.examTime,
      });
    }
  };
  render() {
    let formData = this.props.formData;
    let exam = formData.exam;
    return (
      <Container>
        {this.state.bookLimit ? (
          <Form>
            <Form.Field>
              <Segment>
                <Header>{this.props.t("general.note")}</Header>
                {this.state.bookLimit}
              </Segment>
              <Button
                onClick={() => {
                  this.setState({
                    examDate: null,
                    examTime: null,
                  });
                  this.props.onBackward();
                }}
                negative
                floated="left"
              >
                <Button.Content visible>
                  <Icon name="left arrow" />
                  {this.props.t("general.previous")}
                </Button.Content>
              </Button>
            </Form.Field>
          </Form>
        ) : (
          <Form>
            <ExamDetails
              step={this.props.step}
              examTitle={exam.title}
              duration={exam.duration}
              cost={exam.cost || 0.0}
            />
            <Form.Field>
              <Segment.Group horizontal>
                <Segment>
                  <Header>{this.props.t("general.nextBooking")}</Header>
                  <Grid columns={1} relaxed="very">
                    <Grid.Column>
                      <p align="center" style={{ padding: 10 }}>
                        {this.state.nextAvailable === null || !this.state.examTime
                          ? ""
                          : (() => {
                            // Reconstruct the proper display from examDate and examTime
                            if (typeof this.state.examTime !== 'string' || !this.state.examTime.includes(':')) {
                              return '';
                            }
                            const [hours, minutes] = this.state.examTime.split(':').map(Number);
                            if (isNaN(hours) || isNaN(minutes)) {
                              return '';
                            }
                            // Extract the calendar date (year, month, day) from examDate in browser TZ
                            const year = this.state.examDate.getFullYear();
                            const month = this.state.examDate.getMonth() + 1; // JS months are 0-indexed
                            const day = this.state.examDate.getDate();
                            // Construct DateTime in Atlantic timezone with the calendar date + time
                            const atlanticDT = DateTime.fromObject(
                              { year, month, day, hour: hours, minute: minutes, second: 0, millisecond: 0 },
                              { zone: 'America/Halifax' }
                            );
                            const userTZ = atlanticDT.setZone(this.timezone);
                            // Get timezone abbreviation and simplify (e.g., "NST" -> "NT")
                            const fullTimezoneAbbr = userTZ.toFormat("z");
                            const timezoneAbbr = fullTimezoneAbbr.replace(/[SD]T$/, "T");
                            // Format the date/time with simplified timezone
                            const currentLang = i18n.language || localStorage.getItem("lang") || "en";
                            const dateFormat = currentLang === "en"
                              ? "MMMM dd, yyyy 'at' h:mm a"
                              : "dd MMMM yyyy 'à' HH:mm";
                            return `${userTZ.toFormat(dateFormat)} ${timezoneAbbr}`;
                           })()}
                      </p>
                    </Grid.Column>
                  </Grid>
                </Segment>
                <Segment>
                  <Header>{this.props.t("general.date")}</Header>
                  <DatePicker
                    disabled={this.state.datePickerLoading}
                    selected={this.state.examDate}
                    onChange={this.updateExamDate}
                    minDate={this.minDate}
                    maxDate={this.maxDate}
                    dateFormat={this.getDatePickerFormat()}
                    locale={this.getDatePickerLocale()}
                    includeDates={this.props.includedDays.map(dateStr => {
                      const dateOnly = dateStr.split('T')[0];
                      return DateTime.fromISO(dateOnly).toJSDate();
                    })}
                    disabledKeyboardNavigation={true}
                  />
                </Segment>
                <Segment>
                  <Header>{this.props.t("general.time")}</Header>
                  <Dropdown
                    fluid
                    disabled={this.state.examDate === null}
                    style={{ marginRight: 10 }}
                    onChange={this.updateExamTime}
                    value={this.state.examTime}
                    key={localStorage.getItem("lang")}
                    placeholder={
                      this.state.examDate
                        ? this.props.t("general.time")
                        : this.props.t("SelectDates.selectDate")
                    }
                    search
                    selection
                    options={this.state.available_times}
                  />
                </Segment>
              </Segment.Group>
            </Form.Field>
            <Segment>
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column>
                    <Button
                      onClick={() => {
                        this.setState({
                          examDate: null,
                          examTime: null,
                        });
                        this.props.onBackward();
                      }}
                      negative
                      floated="left"
                    >
                      <Button.Content visible>
                        <Icon name="left arrow" />
                        {this.props.t("general.previous")}
                      </Button.Content>
                    </Button>
                  </Grid.Column>
                  <Grid.Column>
                    <Button
                      onClick={this.onSubmit}
                      disabled={
                        this.state.examDate == null ||
                        this.state.examTime == null
                      }
                      positive
                      floated="right"
                    >
                      <Button.Content visible>
                        {this.props.submitButtonText || this.props.t("general.next")}
                        {!this.props.submitButtonText && <Icon name="right arrow" />}
                      </Button.Content>
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>
          </Form>
        )}
      </Container>
    );
  }
}

export default withTranslation()(
  connect(
    (state) => ({
      kc: state.keycloak,
      exam: state.exam,
      includedDays: state.bookings.includedDays,
      blockedDaysInMonth: state.bookings.blockedDaysInMonth,
      userBookings: state.bookings.userBookings,
      nextBooking: state.nextBooking,
    }),
    {
      fetchBookingTimesForDate,
      getBlockedDaysForSixMonths,
      fetchBookingsForUser,
      fetchNextAvailableBooking,
      getIncludedDaysForSixMonths,
    }
  )(SelectDates)
);
